var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69995 18.5002C3.69995 14.575 5.25923 10.8106 8.03477 8.03502C10.8103 5.25948 14.5747 3.7002 18.5 3.7002V18.5002H33.3C33.3 22.4254 31.7407 26.1898 28.9651 28.9654C26.1896 31.7409 22.4252 33.3002 18.5 33.3002C14.5747 33.3002 10.8103 31.7409 8.03477 28.9654C5.25923 26.1898 3.69995 22.4254 3.69995 18.5002Z",
    fill: "#3AC977"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 4.16602C24.7597 4.82917 27.0954 6.16484 28.9652 8.03459C30.8349 9.90433 32.1706 12.2401 32.8337 14.7998H22.2V4.16602Z",
    fill: "#3AC977"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversal);
export default __webpack_public_path__ + "static/media/universal.31913c2ea3e700b9ec75cf72d9a64bd7.svg";
export { ForwardRef as ReactComponent };